// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__20giA","footer":"Form_footer__CKO7Z"};